var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayers = function SvgLayers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 9.00005V19C4.2 19.4419 4.55817 19.8 5 19.8H15C15.3957 19.8 15.7243 19.5127 15.7886 19.1354H16.9955C16.9259 20.1768 16.0591 21 15 21H5C3.89543 21 3 20.1046 3 19V9.00005C3 7.94139 3.82255 7.07484 4.86341 7.00464V8.21166C4.48665 8.27648 4.2 8.60479 4.2 9.00005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4.2H9C8.55817 4.2 8.2 4.55817 8.2 5V15C8.2 15.4418 8.55817 15.8 9 15.8H19C19.4418 15.8 19.8 15.4418 19.8 15V5C19.8 4.55817 19.4418 4.2 19 4.2ZM9 3C7.89543 3 7 3.89543 7 5V15C7 16.1046 7.89543 17 9 17H19C20.1046 17 21 16.1046 21 15V5C21 3.89543 20.1046 3 19 3H9Z"
  })));
};
export default SvgLayers;